/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextArticleTIcon20Light = forwardRef('TextArticleTIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M1.5 2.5A.5.5 0 0 1 2 2h5a.5.5 0 0 1 0 1H5v4.5a.5.5 0 0 1-1 0V3H2a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M10.5 3a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Z" }),
        React.createElement("path", { d: "M10 7.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M3.5 11a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1h-13Z" }),
        React.createElement("path", { d: "M3.5 15a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1h-13Z" })));
});
